module.exports = __webpack_public_path__ + "static/media/godishen_doklad_2016.e8d02305.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2017/godishen_doklad_2016.pdf
// module id = 160
// module chunks = 0